import { useEffect, useState } from "react";

import useBuddy from "@/hooks/useBuddy";

interface Config {
  buddy?: string;
  showPrompts?: boolean;
  defaultPrompt1?: string;
  defaultPrompt2?: string;
  defaultPrompt3?: string;
  defaultPrompt4?: string;
}

const useLoadConfig = (config: Config | undefined) => {
  const { setBuddyId } = useBuddy();
  const [showPrompts, setShowPrompts] = useState<boolean>(false);
  const [defaultPrompt1, setDefaultPrompt1] = useState<string>("");
  const [defaultPrompt2, setDefaultPrompt2] = useState<string>("");
  const [defaultPrompt3, setDefaultPrompt3] = useState<string>("");
  const [defaultPrompt4, setDefaultPrompt4] = useState<string>("");

  useEffect(() => {
    if (config) {
      setBuddyId(config.buddy || "");
      setShowPrompts(config.showPrompts || false);
      setDefaultPrompt1(config.defaultPrompt1 || "");
      setDefaultPrompt2(config.defaultPrompt2 || "");
      setDefaultPrompt3(config.defaultPrompt3 || "");
      setDefaultPrompt4(config.defaultPrompt4 || "");
    }
  }, [config]);

  return {
    showPrompts,
    defaultPrompts: [defaultPrompt1, defaultPrompt2, defaultPrompt3, defaultPrompt4],
  };
};

export default useLoadConfig;
